<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :tree-config="{
        children: 'children',
        expandAll: true,
      }"
      row-id="shipmentPayStatementItemCode"
    >
      <template v-slot:showItem="{ row }">
        <el-row :gutter="10">
          <el-row :gutter="10" v-if="row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                {{ row.shipmentPayStatementNo }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                费用项目：
                {{ row.expenseName }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                财务费用：
                {{ row.v_expenseType }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 4 }"
            >
              <span>
                计费数量：
                {{ row.chargeQty }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                计费单价：
                {{ row.v_currencyUnitPrice }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                费用合计：
                {{ row.v_currencyTotalAmount }}
              </span>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="!row.children">
            <el-col
              :xs="{ span: 24 }"
              :sm="{ span: 12 }"
              :md="{ span: 12 }"
              :lg="{ span: 5 }"
            >
              <span>
                说明：
                {{ row.remark }}
              </span>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
